/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SnapDisplayComment = {
    id: number;
    comment: string;
    referenceCode?: string;
    opsUserId?: number;
    opsUserEmail?: string;
    opsUserRole?: SnapDisplayComment.opsUserRole;
    resolutionStatus?: SnapDisplayComment.resolutionStatus;
    resolutionReason?: string;
    isEscalate?: boolean;
    createdAt: string;
    type: SnapDisplayComment.type;
};

export namespace SnapDisplayComment {

    export enum opsUserRole {
        ADMIN = 'ADMIN',
        OPERATOR = 'OPERATOR',
    }

    export enum resolutionStatus {
        PENDING = 'PENDING',
        CONFIRMED = 'CONFIRMED',
        PARTIALLY_CONFIRMED = 'PARTIALLY_CONFIRMED',
        DECLINED = 'DECLINED',
    }

    export enum type {
        COMMENT = 'COMMENT',
        CLAIM = 'CLAIM',
    }


}

